
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import PickerDate from '@/components/picker-date.vue';
	import {
		providerSelectItem
	} from '@/api/supplier';
  import {
    orderInvoiceorderInvoiceList
  } from "@/api/finance"
  import {
    getSearchDate,
    nextDay
  } from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })
  export default class ProductList extends Vue {
    private filterTime = []
    private keywords = ''
    private supplierNameKey = ''
    private supplier:any = []
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1
    private pageSize = 20
    private total = 0




    private mounted () {
      this.initTime()
      this.getSupplierList()
      this.gettablelist()
    }

    
    private toDetails(row){
      let data:any = {
        ProviderId:row.ProviderId,
        ProductId:row.ProductId,
      }
      if(this.filterTime.length){
        data.StartTime = this.filterTime[0]
        data.EndTime = nextDay(this.filterTime[1],1)
      }
      this.$router.push({
        path:'userInvoiceScheduleDetails',
        query:data
      })
    }
    // 获取供应商列表
		private async getSupplierList() {
			try {
				const res: any = await providerSelectItem({});
				this.supplier = res.Result.map(v => {
					return {
						value: v.Id,
						label: v.ProviderName
					}
				})
			} catch (e) {
				console.log('supplierList ===>', e);
			}
		}
    private initTime(){
      let date = new Date()
      let year = date.getFullYear()
      this.filterTime = [`${year}-01-01`,getSearchDate(0,false)[0]]
    }
    private clearSearch(){
      this.initTime()
      this.keywords = ''
      this.supplierNameKey = ''
      this.doSearch()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          ProviderId:this.supplierNameKey,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if(this.filterTime.length){
          data.StartTime = this.filterTime[0]
          data.EndTime = nextDay(this.filterTime[1],1)
        }
        let res:any = await orderInvoiceorderInvoiceList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private exportFile(){
      let url = location.origin + '/pc/orderInvoice/orderInvoiceListExport'
      url += '?Keywords=' + encodeURI(this.keywords)
      url += '&ProviderId=' + (this.supplierNameKey==null?'':this.supplierNameKey)
      if(this.filterTime.length){
        url += '&StartTime=' + this.filterTime[0]
        url += '&EndTime=' + nextDay(this.filterTime[1],1)
      }
      window.open(url)
    }
  }
